// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'search';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1.104 10.018A6.797 6.797 0 1 0 13.616 4.7a6.797 6.797 0 0 0-12.512 5.318zm11.062 2.147 5.272 5.272'
  />
);

export const viewBox = '0 0 18 18';
